import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "@/api/auth";
import { AuthShell, AuthSubmit } from "@/components/AuthShell";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell subtitle={sent ? "Check your inbox" : "Reset your password"}>
      {sent ? (
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-ef-ok/25 bg-ef-ok/10 text-2xl text-ef-ok">
            ✓
          </div>
          <p className="text-[13px] leading-relaxed text-ef-textDim">
            We sent a password reset link to <span className="font-medium text-ef-text">{email}</span>. Check
            your inbox and follow the instructions.
          </p>
          <Link
            to="/login"
            className="mt-5 block w-full rounded-[var(--radius)] border border-ef-border bg-ef-panel2 py-[11px] text-center text-sm text-ef-text hover:border-ef-accent"
          >
            Back to login
          </Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="flex flex-col gap-3.5">
          <label className="block">
            <span className="mb-1.5 block text-xs font-medium text-ef-textDim">Email</span>
            <input
              type="email"
              required
              autoFocus
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="ef-input"
            />
          </label>
          <AuthSubmit loading={busy} disabled={!email}>{busy ? "Sending…" : "Send reset link"}</AuthSubmit>
          <Link to="/login" className="py-2 text-center text-[13px] text-ef-textDim hover:text-ef-text">
            ← Back to login
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
